import { __rest } from "tslib";
import React from "react";
import { useGraphTime } from "./GraphTimeProvider";
import { unix2mjd } from "./helpers/timeParser";
import { GrafosSymbol } from "./interfaces/element";
import { ScatterGL } from "./ScatterGL";
import { getRealTimeData } from "./utils";
import { WrapperGL } from "./WrapperGL";
export const TimeChangingElement = (_a) => {
    var { element, xMapper, domainX, data, ignoreFileName, yElementMapper, yScale, y2Scale, getYDomain, color } = _a, other = __rest(_a, ["element", "xMapper", "domainX", "data", "ignoreFileName", "yElementMapper", "yScale", "y2Scale", "getYDomain", "color"]);
    const { graphTime } = useGraphTime();
    const elementDomainY = element.colY
        ? getYDomain(yScale, yElementMapper)
        : getYDomain(y2Scale, yElementMapper);
    const { xKey, yKey, timedData } = React.useMemo(() => getRealTimeData(data, element, ignoreFileName, unix2mjd(graphTime)), [data, element, graphTime, ignoreFileName]);
    return (React.createElement(React.Fragment, null,
        React.createElement(WrapperGL, Object.assign({ data: timedData, idValue: yKey, xMapper: xMapper, yMapper: yElementMapper, domainX: domainX, domainY: elementDomainY, xKey: xKey }, other),
            React.createElement(ScatterGL, { show: true, symbol: GrafosSymbol.circle, thickness: element.symbolSize * 4, color: color }))));
};
//# sourceMappingURL=TimeChangingElement.js.map